import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import selectErrors from '../../../reducers/errorreducer/selectors/selectErrors';

import OutputText from '@ey/canvascoreservices/OutputText';

import Toast from '../../CoreWrappers/Toast';
import StyledNotifcations from './StyledNotifcations';

const Notifications = ({isModal = false}) => {
	const [notifications, isModalOpen = false] = selectErrors();

	const show = (isModal && isModalOpen) || (!isModal && !isModalOpen);

	const renderNotification = (n, i) => {
		const props = {
			key: i,
			message: (
				<>
					{n.code && <OutputText bold>{n.code}: </OutputText>}
					{n.message}
				</>
			),
			variant: n.level
		};

		return <Toast {...props} />;
	};

	return (
		<>
			{show && (
				<StyledNotifcations className={classNames('notifications', {modal: isModal})}>
					{notifications.map(renderNotification)}
				</StyledNotifcations>
			)}
		</>
	);
};

Notifications.propTypes = {
	isModal: PropTypes.bool
};

export default Notifications;
